export const cartKeys = {
   cart: ['shopify-cart'],
};
